import csv from 'papaparse';

export function readFileContentAsString(file: File) {
  return new Promise<string>((resolve, reject) => {
    try {
      const reader = new FileReader();
      reader.onload = (event) =>
        event.target && resolve(event.target.result as string);
      reader.readAsText(file);
    } catch (err) {
      reject(err);
    }
  });
}

export function createFileListFromArray(files: File[]): FileList {
  return {
    ...files,
    length: files.length,
    item: (index: number) => {
      return files[index];
    },
  };
}

export function convertCsvToArray<T = any>(data: string) {
  try {
    return csv.parse<string[]>(data).data as T[][];
  } catch (err) {
    console.error('[convertCsvToArray]', err);
  }

  return undefined;
}

export function convertCsvToObjectArray<T = any>(data: string) {
  try {
    const [headers, ...values] = convertCsvToArray(data) || [];

    return values.reduce((all: any[], row: any[]) => {
      const item: Record<string, string> = headers.reduce(
        (all2, x, i) => ({
          ...all2,
          [x]: row[i as any],
        }),
        {}
      );

      return [...all, item];
    }, []) as T[];
  } catch (err) {
    console.error('[convertCsvToObject]', err);
  }

  return undefined;
}

export function createFileFromString(
  data: string,
  filename = 'file.txt',
  mimeType = 'text/plain'
) {
  const blob = new Blob([data], { type: mimeType });
  return new File([blob], filename, { type: mimeType });
}

const parseDimension = (dimension: string | null): number => {
  return dimension ? Number(dimension.replace('px', '')) || 0 : 0;
};
export const validateSvgFileDimensions = (
  file: File,
  requiredDimension: number
): Promise<boolean> => {
  return new Promise((resolve, reject) => {
    if (file.type !== 'image/svg+xml') {
      return reject(new Error('The file is not a valid SVG.'));
    }

    const reader = new FileReader();

    reader.onload = (event) => {
      const result = event.target?.result;

      if (typeof result !== 'string') {
        return reject(new Error('Failed to read the SVG file.'));
      }

      try {
        const parser = new DOMParser();
        const svgDoc = parser.parseFromString(result, 'image/svg+xml');
        const svgElement = svgDoc.querySelector('svg');

        if (!svgElement) {
          return reject(
            new Error('The file does not contain a valid SVG element.')
          );
        }

        const width = parseDimension(svgElement.getAttribute('width'));
        const height = parseDimension(svgElement.getAttribute('height'));

        if (width !== requiredDimension || height !== requiredDimension) {
          return reject(
            new Error('SVG dimensions do not match the required size.')
          );
        }

        resolve(true);
      } catch (error) {
        reject(new Error('An error occurred while parsing the SVG.'));
      }
    };

    reader.onerror = () => {
      reject(new Error('An error occurred while reading the file.'));
    };

    reader.readAsText(file);
  });
};
